import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["placeholder"];
import React from 'react';
import { Textarea } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
function TextArea(_ref) {
  let {
      placeholder
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useWeb5Context();
  return /*#__PURE__*/React.createElement(Textarea, _extends({
    labelMode: "horizontal",
    placeholder: placeholder || t('cfm_placeholder_type_value')
  }, props));
}
export default TextArea;